module.exports = __webpack_public_path__ + "static/img/passionfruit_th.1a816fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/passionfruit_th.png
// module id = Ngtl
// module chunks = 0